import React from 'react';
import { motion } from 'framer-motion';

interface LandingHeroProps {
  onSignInClick: () => void;
  brandPrimary: string;
  brandSecondary: string;
  brandDark: string;
  fadeInUp: any;
  staggerContainer: any;
  scaleUp: any;
}

export const LandingHero: React.FC<LandingHeroProps> = ({
  onSignInClick,
  brandPrimary,
  brandSecondary,
  brandDark,
  fadeInUp,
  staggerContainer,
  scaleUp,
}) => {
  return (
    <>
      <section style={{ padding: '2rem 5% 6rem', textAlign: 'center', maxWidth: '1000px', margin: '0 auto' }}>
        <motion.div initial="hidden" animate="visible" variants={staggerContainer}>
          <motion.h2
            variants={fadeInUp}
            style={{
              fontSize: 'clamp(3.2rem, 6.5vw, 5.2rem)',
              fontWeight: 800,
              margin: '0 0 1.5rem 0',
              lineHeight: 1.08,
              letterSpacing: '-0.04em',
            }}
          >
            Photos & 4K video,<br />
            <span style={{ color: brandPrimary, position: 'relative' }}>
              supercharged.
              <svg
                style={{ position: 'absolute', bottom: '-10px', left: 0, width: '100%', height: '20px' }}
                viewBox="0 0 200 20"
                preserveAspectRatio="none"
              >
                <path d="M0,15 C50,0 150,0 200,15" fill="none" stroke={brandSecondary} strokeWidth="4" strokeLinecap="round" />
              </svg>
            </span>
          </motion.h2>
          <motion.p
            variants={fadeInUp}
            style={{
              fontSize: '1.25rem',
              color: '#4B5563',
              marginBottom: '2rem',
              fontWeight: 500,
              maxWidth: '680px',
              margin: '0 auto 2rem',
              lineHeight: 1.6,
            }}
          >
            The private cloud media vault built for families, creative studios, and modern businesses. Store uncompressed RAW & 4K video, stream with zero lag, proof client galleries, and search with Edge AI.
          </motion.p>
          <motion.div
            variants={fadeInUp}
            style={{
              display: 'flex',
              gap: '0.6rem',
              flexWrap: 'wrap',
              justifyContent: 'center',
              marginBottom: '2.5rem',
            }}
          >
            <span style={{ background: '#EDE9FE', color: brandPrimary, padding: '0.4rem 1rem', borderRadius: '20px', fontSize: '0.85rem', fontWeight: 700 }}>
              🏠 Families & Personal
            </span>
            <span style={{ background: '#FEF3C7', color: '#B45309', padding: '0.4rem 1rem', borderRadius: '20px', fontSize: '0.85rem', fontWeight: 700 }}>
              📸 Studios & Photographers
            </span>
            <span style={{ background: '#E0F2FE', color: '#0369A1', padding: '0.4rem 1rem', borderRadius: '20px', fontSize: '0.85rem', fontWeight: 700 }}>
              💼 Business & Team Workspaces
            </span>
            <span style={{ background: '#DCFCE7', color: '#15803D', padding: '0.4rem 1rem', borderRadius: '20px', fontSize: '0.85rem', fontWeight: 700 }}>
              ⚡ 0 Egress Bandwidth Fees
            </span>
          </motion.div>
          <motion.div variants={fadeInUp} style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginBottom: '4rem' }}>
            <a
              href="#pricing"
              style={{
                background: brandPrimary,
                color: 'white',
                padding: '1.1rem 2.5rem',
                borderRadius: '40px',
                textDecoration: 'none',
                fontWeight: 700,
                fontSize: '1.1rem',
                boxShadow: '0 10px 25px rgba(124,58,237,0.3)',
              }}
            >
              Start Free
            </a>
            <button
              onClick={onSignInClick}
              style={{
                background: 'white',
                color: brandDark,
                border: '2px solid #E5E7EB',
                padding: '1.1rem 2.5rem',
                borderRadius: '40px',
                fontWeight: 700,
                fontSize: '1.1rem',
                cursor: 'pointer',
                boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
              }}
            >
              Live Demo
            </button>
          </motion.div>

          {/* Ente-Style Stacked Photo Collage */}
          <motion.div
            variants={scaleUp}
            style={{
              position: 'relative',
              height: '450px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '3rem',
              width: '100%',
              maxWidth: '1000px',
              margin: '3rem auto 0',
            }}
          >
            <motion.img
              src="https://images.unsplash.com/photo-1511895426328-dc8714191300?q=80&w=600&auto=format&fit=crop"
              style={{
                position: 'absolute',
                width: '280px',
                height: '340px',
                borderRadius: '24px',
                objectFit: 'cover',
                border: '8px solid white',
                boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                transform: 'rotate(-15deg) translateX(-320px) translateY(40px)',
                zIndex: 1,
              }}
            />
            <motion.img
              src="https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?q=80&w=600&auto=format&fit=crop"
              style={{
                position: 'absolute',
                width: '300px',
                height: '380px',
                borderRadius: '24px',
                objectFit: 'cover',
                border: '8px solid white',
                boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
                transform: 'rotate(-6deg) translateX(-160px) translateY(10px)',
                zIndex: 2,
              }}
            />
            <motion.img
              src="https://images.unsplash.com/photo-1506869640319-ce1a46062c5e?q=80&w=600&auto=format&fit=crop"
              style={{
                position: 'absolute',
                width: '340px',
                height: '420px',
                borderRadius: '24px',
                objectFit: 'cover',
                border: '8px solid white',
                boxShadow: '0 30px 60px rgba(0,0,0,0.2)',
                transform: 'rotate(2deg) translateX(0px) translateY(-10px)',
                zIndex: 4,
              }}
            />
            <motion.img
              src="https://images.unsplash.com/photo-1542038784456-1ea8e935640e?q=80&w=600&auto=format&fit=crop"
              style={{
                position: 'absolute',
                width: '300px',
                height: '380px',
                borderRadius: '24px',
                objectFit: 'cover',
                border: '8px solid white',
                boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
                transform: 'rotate(8deg) translateX(160px) translateY(20px)',
                zIndex: 3,
              }}
            />
            <motion.img
              src="https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?q=80&w=600&auto=format&fit=crop"
              style={{
                position: 'absolute',
                width: '280px',
                height: '340px',
                borderRadius: '24px',
                objectFit: 'cover',
                border: '8px solid white',
                boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                transform: 'rotate(16deg) translateX(320px) translateY(50px)',
                zIndex: 1,
              }}
            />
          </motion.div>
        </motion.div>
      </section>

      {/* Hero Sub-Banner: Search & AI */}
      <section
        style={{
          background: brandDark,
          color: 'white',
          padding: '6rem 5%',
          textAlign: 'center',
          borderRadius: '40px',
          maxWidth: '1200px',
          margin: '0 auto 4rem',
        }}
      >
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={staggerContainer}>
          <motion.h2
            variants={fadeInUp}
            style={{ fontSize: 'clamp(2.5rem, 5vw, 3.5rem)', fontWeight: 800, margin: '0 0 1.5rem 0', letterSpacing: '-0.03em' }}
          >
            Find, stream, and share <span style={{ color: brandSecondary }}>anything</span>. Instantly.
          </motion.h2>
          <motion.p
            variants={fadeInUp}
            style={{ fontSize: '1.25rem', opacity: 0.9, maxWidth: '650px', marginBottom: '3rem', lineHeight: 1.6 }}
          >
            Type &quot;client headshot&quot;, &quot;4K drone footage&quot;, or tap any face. Our <strong>Edge AI</strong> indexes visual contents and EXIF tags in milliseconds, while our media engine streams full HD & 4K video on demand.
          </motion.p>
          <motion.div variants={fadeInUp} style={{ display: 'flex', gap: '0.8rem', flexWrap: 'wrap', justifyContent: 'center' }}>
            <span style={{ background: 'rgba(255,255,255,0.1)', padding: '0.8rem 1.5rem', borderRadius: '30px', fontWeight: 600 }}>🔍 Semantic AI Search</span>
            <span style={{ background: 'rgba(255,255,255,0.1)', padding: '0.8rem 1.5rem', borderRadius: '30px', fontWeight: 600 }}>👦 Face Clustering</span>
            <span style={{ background: 'rgba(255,255,255,0.1)', padding: '0.8rem 1.5rem', borderRadius: '30px', fontWeight: 600 }}>🎥 4K Video Streaming</span>
            <span style={{ background: 'rgba(255,255,255,0.1)', padding: '0.8rem 1.5rem', borderRadius: '30px', fontWeight: 600 }}>🤝 Client Proofing & Dropboxes</span>
            <span style={{ background: 'rgba(255,255,255,0.1)', padding: '0.8rem 1.5rem', borderRadius: '30px', fontWeight: 600 }}>📁 Direct-to-Disk Takeout</span>
          </motion.div>
        </motion.div>
      </section>
    </>
  );
};
